import { takeEvery } from "redux-saga/effects";
import { loginRedux } from "../redux/login-redux/LoginRedux";
import ApiServices from "../services/ApiServices";
import {
  checkUserNameAvaibilitySaga,
  createProfilePhoneNumberOtpResendSaga,
  createProfilePhoneNumberOtpVerifySaga,
  createProfileSaga,
  createSkillsSaga,
  createUserNameSaga,
  disconnectAndDestroySessionIdSaga,
  generateSessionIdSaga,
  getAllCategoriesSaga,
  getAllLoginDetailsSaga,
  getAllRolesSaga,
  getAllSkillsSaga,
  logOutDifferentUserSaga,
  logOutUserSaga,
  loginOtpSaga,
  loginOtpVerifySaga,
  refreshAuthTokenSaga,
  registerOtpSaga,
  registerOtpVerifySaga,
  registerResendOtpSaga,
  registerWithFacebookOAuth,
  registerWithGoogleOAuth,
  resendLoginOtpSaga,
  updateEmailSaga,
  updatePhoneNumberSaga,
  updateFCMTokenSaga,
  DeleteUserSaga,
  BlockUserSaga,
  CreateUserAddSkills,
} from "./LoginSaga";
import { createPostRedux } from "../redux/create-post-redux/CreatePostRedux";
import {
  createPostSaga,
  deletePostSaga,
  getAllPostsByUserIdSaga,
  getPostDetailsByPostIdSaga,
  updatePostSaga,
} from "./CreatePostSaga";
import { ProfileRedux } from "../redux/profile-redux/ProfileRedux";
import {
  deleteProfilePictureSaga,
  followOrUnFollowUserSaga,
  getAllFollowersSaga,
  getAllFollowingSaga,
  getAllSavedPostSaga,
  searchUserInFollowersListSaga,
  searchUserInFollowingListSaga,
  getLikedPostSaga,
  getProfileDetailsByIdSaga,
  searchUserInLikeListsSaga,
  likeOrUnlikePostApiSaga,
  saveOUnsavePostToFavouriteSaga,
  updateProfileDetailsSaga,
  uploadProfilePicturesToBackendSaga,
  getAllShareUsersSaga,
  searchUserInShareListSaga,
  getAllMutualsSaga,
  getPostViewsSaga,
} from "./ProfileSaga";
import { CommentRedux } from "../redux/comment-redux/CommentRedux";
import {
  addCommentsSaga,
  addReplySaga,
  deleteCommentSaga,
  deleteReplySaga,
  getAllCommentsByPostIdSaga,
  getCommentRepliesByCommentIdRequestSaga,
} from "./CommentsSaga";
import { getHomePostSaga } from "./HomeSaga";
import { homeRedux } from "../redux/home-redux/HomeRedux";
import { postFilterInExplore, projectFilterInExplore, SearchProfilesInExploreSaga, serachAllProjectsInExplore, serachArtistsInExplore, serachPostsInExplore, serachProjectsInExplore, userFilterInExplore } from "./ExploreSaga";
import { exploreRedux } from "../redux/explore-redux/ExploreRedux";
import { createProjectRedux } from "../redux/create-project-redux/CreateProjectRedux";
import {
  createProject,
  getAllMyCollaboratedProjects,
  getAllMyProjects,
  getAllSavedProjects,
  getUsersListBasedOnSkillId,
  saveProject,
  updateProject,
  uploadProjectMedia,
} from "./CreateProjectSaga";
import { dashboardRedux } from "../redux/dashboard-redux/DashboardRedux";
import {
  getAllMyProjectsBasedOnStatus,
  getAllMyCollaboratedProjectsBasedOnStatus,
  getProjectDetailsById,
  applyProject,
  getDashboardData,
  getAllArtistsOfProjectByInviteStatus,
  removeCollaboratorById,
  getCollaboratorNegotiationDetails,
  acceptOrDeclineCollaborationRequest,
  rejectProjectInvite,
  inviteCollaborator,
  getAllInvitedCollaborators,
  exitProject,
  reNegotiation,
  endProject,
  getAllCollaborators,
  acceptInvitation,
  getProjectTasks,
  createProjectTask,
  getAllAssigneesByTaskId,
  getAllUnassignedArtistsByTaskId,
  removeAssignedArtists,
  updateTaskById,
  getTaskDetailsById,
  selfTaskAssignment,
  deleteProject,
  getProjectMedias,
  createMeeting,
  getAllMeetings,
  deleteMeeting,
  updateMeeting,
  getAllMeetingsById,
  reportPost,
  reportProject,
  getAllProjectTasks,
  getAllProjectMembers,
  deleteTask,
  fetchProjectContractSaga,
  reportUser,
  reportComment,
  reportReply,
  reportProblem,
  projectViewCountSaga,
  rateProject,
} from "./DashboardSaga";
import { chatRedux } from "../redux/chat-redux/ChatRedux";
import { createProjectGroupSaga, getAllCollabaratorsByProjectIdSaga, getProjectGroupDetailsSaga } from "./ChatSaga";
import { projectMeetingRedux } from "../redux/dashboard-redux/project-meetings-redux/ProjectMeetingsRedux";
import { reportRedux } from "../redux/help-and-support-redux/reportRedux";
import { getAllUserNotificationsSaga, updateNotificationSaga } from "./NotificationSaga";
import { notificationsRedux } from "../redux/notification-redux/NotificationsRedux";
import { eventsRedux } from "../redux/events-redux/EventsRedux";
import { createRazorpayOrderSaga, getRefundSaga, registerUserInEventSaga, verifyPromoCodeSaga } from "./EventSaga";

export const api = ApiServices.create();

export default function* root() {
  yield takeEvery(loginRedux.actions.loginOtpRequest, loginOtpSaga, api);
  yield takeEvery(
    loginRedux.actions.loginOtpVerifyRequest,
    loginOtpVerifySaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.resendLoginOtpRequest,
    resendLoginOtpSaga,
    api
  );
  yield takeEvery(loginRedux.actions.registerOtpRequest, registerOtpSaga, api);
  yield takeEvery(
    loginRedux.actions.registerOtpVerifyRequest,
    registerOtpVerifySaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.registerResendOtpRequest,
    registerResendOtpSaga,
    api
  );

  // get All Login details
  yield takeEvery(
    loginRedux.actions.getAllLoginRequest,
    getAllLoginDetailsSaga,
    api
  );
  // change email
  yield takeEvery(
    loginRedux.actions.updateEmailRequest,
    updateEmailSaga,
    api
  );
  //change phone number
  yield takeEvery(
    loginRedux.actions.updatePhoneRequest,
    updatePhoneNumberSaga,
    api
  );
  // set user FCM token for notifications
  yield takeEvery(
    loginRedux.actions.updateFCMTokenRequest,
    updateFCMTokenSaga,
    api
  );
  // delete user account
  yield takeEvery(loginRedux.actions.deleteAccountRequest, DeleteUserSaga, api);

  // block user account
  yield takeEvery(loginRedux.actions.blockUserRequest, BlockUserSaga, api);

  yield takeEvery(
    loginRedux.actions.createProfileRequest,
    createProfileSaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.addUserSkillsRequest,
    CreateUserAddSkills,
    api
  );
  yield takeEvery(
    loginRedux.actions.createProfilePhoneNumberOtpVerifyRequest,
    createProfilePhoneNumberOtpVerifySaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.createProfileResendPhoneNumberOtpRequest,
    createProfilePhoneNumberOtpResendSaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.checkUserNameAvaibilityRequest,
    checkUserNameAvaibilitySaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.createUserNameRequest,
    createUserNameSaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.registerWithGoogleRequest,
    registerWithGoogleOAuth,
    api
  );
  yield takeEvery(
    loginRedux.actions.registerWithFacebookRequest,
    registerWithFacebookOAuth,
    api
  );

  // skills
  yield takeEvery(
    loginRedux.actions.getAllSkillsRequest,
    getAllSkillsSaga,
    api
  );
  yield takeEvery(loginRedux.actions.createSkillRequest, createSkillsSaga, api);
  // roles
  yield takeEvery(loginRedux.actions.getAllRolesRequest, getAllRolesSaga, api);
  // categories
  yield takeEvery(
    loginRedux.actions.getAllCategoriesRequest,
    getAllCategoriesSaga,
    api
  );

  yield takeEvery(
    createPostRedux.actions.createPostRequest,
    createPostSaga,
    api
  );

  // profile
  yield takeEvery(
    ProfileRedux.actions.followOrUnFollowUserRequest,
    followOrUnFollowUserSaga,
    api
  );

  yield takeEvery(
    ProfileRedux.actions.getAllFollowingRequest,
    getAllFollowingSaga,
    api
  );

  yield takeEvery(
    ProfileRedux.actions.getAllShareRequest,
    getAllShareUsersSaga,
    api
  );

  yield takeEvery(
    ProfileRedux.actions.getAllFollowerRequest,
    getAllFollowersSaga,
    api
  );

  yield takeEvery(
    ProfileRedux.actions.getAllMutualRequest,
    getAllMutualsSaga,
    api
  );

  yield takeEvery(
    createPostRedux.actions.getPostDetailsByPostIdRequest,
    getPostDetailsByPostIdSaga,
    api
  );
  yield takeEvery(
    createPostRedux.actions.getAllPostsByUserIdRequest,
    getAllPostsByUserIdSaga,
    api
  );
  yield takeEvery(
    createPostRedux.actions.deletePostRequest,
    deletePostSaga,
    api
  );
  yield takeEvery(
    createPostRedux.actions.updatePostRequest,
    updatePostSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.updateProfileDetailsRequest,
    updateProfileDetailsSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.getProfileDetailsByIdRequest,
    getProfileDetailsByIdSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.searchUserInFollowingListRequest,
    searchUserInFollowingListSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.searchUserInFollowersListRequest,
    searchUserInFollowersListSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.searchUserInShareListRequest,
    searchUserInShareListSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.getAllSavedPostRequest,
    getAllSavedPostSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.saveOrUnsavePostToFavouriteRequest,
    saveOUnsavePostToFavouriteSaga,
    api
  );

  yield takeEvery(
    ProfileRedux.actions.getLikedPostRequest,
    getLikedPostSaga,
    api
  );

  yield takeEvery(
    ProfileRedux.actions.getPostViewRequest,
    getPostViewsSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.likeOrUnlikePostRequest,
    likeOrUnlikePostApiSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.searchUserInLikeListsRequest,
    searchUserInLikeListsSaga,
    api
  );
  yield takeEvery(
    ProfileRedux.actions.getProfileDetailsByIdRequest,
    getProfileDetailsByIdSaga,
    api
  );

  // profile and cover pictures upload to backend
  yield takeEvery(
    ProfileRedux.actions.uploadProfilePictureToBackendRequest,
    uploadProfilePicturesToBackendSaga,
    api
  );
  // comments Apis

  yield takeEvery(
    CommentRedux.actions.getAllCommentsByPostIdRequest,
    getAllCommentsByPostIdSaga,
    api
  );
  yield takeEvery(
    CommentRedux.actions.getCommentRepliesByCommentIdRequest,
    getCommentRepliesByCommentIdRequestSaga,
    api
  );
  yield takeEvery(
    CommentRedux.actions.addCommentsRequest,
    addCommentsSaga,
    api
  );
  yield takeEvery(CommentRedux.actions.addReplyRequest, addReplySaga, api);
  yield takeEvery(
    CommentRedux.actions.deleteCommentRequest,
    deleteCommentSaga,
    api
  );
  yield takeEvery(
    CommentRedux.actions.deleteReplyRequest,
    deleteReplySaga,
    api
  );

  // home saga;
  yield takeEvery(homeRedux.actions.getHomePostRequest, getHomePostSaga, api);
  yield takeEvery(
    ProfileRedux.actions.deleteProfilePicturesRequest,
    deleteProfilePictureSaga,
    api
  );
  yield takeEvery(loginRedux.actions.logOutRequest, logOutUserSaga, api);
  yield takeEvery(loginRedux.actions.logOutDifferentUserRequest, logOutDifferentUserSaga, api);
  yield takeEvery(
    loginRedux.actions.refreshAuthTokenRequest,
    refreshAuthTokenSaga,
    api
  );

  // Explore
  yield takeEvery(exploreRedux.actions.searchProfilesIInExploreRequest, SearchProfilesInExploreSaga, api);
  yield takeEvery(exploreRedux.actions.serachPostsInExploreRequest, serachPostsInExplore, api);
  yield takeEvery(exploreRedux.actions.serachProjectsInExploreRequest, serachProjectsInExplore, api);
  yield takeEvery(exploreRedux.actions.serachAllProjectsInExploreRequest, serachAllProjectsInExplore, api);
  yield takeEvery(exploreRedux.actions.serachArtistInExploreRequest, serachArtistsInExplore, api);
  yield takeEvery(exploreRedux.actions.projectFilterInExploreRequest, projectFilterInExplore, api);
  yield takeEvery(exploreRedux.actions.postFilterInExploreRequest, postFilterInExplore, api);
  yield takeEvery(exploreRedux.actions.userFilterInExploreRequest, userFilterInExplore, api);

  // Create project apis
  yield takeEvery(
    createProjectRedux.actions.getUsersListBasedOnSkillIdRequest,
    getUsersListBasedOnSkillId,
    api
  );
  yield takeEvery(
    createProjectRedux.actions.createProjectRequest,
    createProject,
    api
  );
  yield takeEvery(
    createProjectRedux.actions.uploadProjectMediaRequest,
    uploadProjectMedia,
    api
  );
  yield takeEvery(
    createProjectRedux.actions.getAllMyProjectsRequest,
    getAllMyProjects,
    api
  );
  yield takeEvery(
    createProjectRedux.actions.getAllMyCollaboratedProjectsRequest,
    getAllMyCollaboratedProjects,
    api
  );
  yield takeEvery(
    createProjectRedux.actions.updateProjectRequest,
    updateProject,
    api
  );
  yield takeEvery(
    createProjectRedux.actions.saveProjectRequest,
    saveProject,
    api
  );
  yield takeEvery(
    createProjectRedux.actions.getAllSavedProjectsRequest,
    getAllSavedProjects,
    api
  );


  //Dashboard apis
  yield takeEvery(
    dashboardRedux.actions.getDashboardDataRequest,
    getDashboardData,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllMyProjectsBasedOnStatusRequest,
    getAllMyProjectsBasedOnStatus,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllMyCollaboratedProjectsBasedOnStatusRequest,
    getAllMyCollaboratedProjectsBasedOnStatus,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getProjectDetailsByIdRequest,
    getProjectDetailsById,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.applyProjectRequest,
    applyProject,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.acceptInvitationRequest,
    acceptInvitation,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllArtistsOfProjectByInviteStatusRequest,
    getAllArtistsOfProjectByInviteStatus,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.removeCollaboratorByIdRequest,
    removeCollaboratorById,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getCollaboratorNegotiationDetailsRequest,
    getCollaboratorNegotiationDetails,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.acceptOrDeclineCollaborationRequest,
    acceptOrDeclineCollaborationRequest,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.rejectProjectInviteRequest,
    rejectProjectInvite,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.inviteCollaboratorRequest,
    inviteCollaborator,
    api
  );

  yield takeEvery(
    dashboardRedux.actions.getAllInvitedCollaboratorsRequest,
    getAllInvitedCollaborators,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllInvitedCollaboratorsRequest,
    getAllInvitedCollaborators,
    api
  );
  yield takeEvery(dashboardRedux.actions.exitProjectRequest, exitProject, api);
  yield takeEvery(
    dashboardRedux.actions.reNegotiationRequest,
    reNegotiation,
    api
  );
  yield takeEvery(dashboardRedux.actions.endProjectRequest, endProject, api);

  yield takeEvery(dashboardRedux.actions.rateProjectRequest, rateProject, api);

  yield takeEvery(dashboardRedux.actions.getProjectContractRequest, fetchProjectContractSaga, api);
  yield takeEvery(
    dashboardRedux.actions.getAllCollaboratorsRequest,
    getAllCollaborators,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllProjectMembersRequest, getAllProjectMembers, api);
  yield takeEvery(
    dashboardRedux.actions.deleteProjectRequest,
    deleteProject,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getProjectMediasRequest,
    getProjectMedias,
    api
  );

  // Tasks
  yield takeEvery(
    dashboardRedux.actions.getProjectTasksRequest,
    getProjectTasks,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllProjectTasksRequest,
    getAllProjectTasks,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.createProjectTaskRequest,
    createProjectTask,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllAssigneesByTaskIdRequest,
    getAllAssigneesByTaskId,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getAllUnassignedArtistsByTaskIdRequest,
    getAllUnassignedArtistsByTaskId,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.removeAssignedArtistsRequest,
    removeAssignedArtists,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.updateTaskByIdRequest,
    updateTaskById,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.deleteTaskRequest,
    deleteTask,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.getTaskDetailsByIdRequest,
    getTaskDetailsById,
    api
  );
  yield takeEvery(
    dashboardRedux.actions.selfTaskAssignmentRequest,
    selfTaskAssignment,
    api
  );

  yield takeEvery(
    dashboardRedux.actions.projectViewCountRequest,
    projectViewCountSaga,
    api
  );

  //project meetings
  yield takeEvery(
    projectMeetingRedux.actions.createProjectMeetingRequest,
    createMeeting,
    api
  );
  yield takeEvery(
    projectMeetingRedux.actions.getAllProjectMeetingsRequest,
    getAllMeetings,
    api
  );
  yield takeEvery(
    projectMeetingRedux.actions.getProjectMeetingsRequest,
    getAllMeetingsById,
    api
  );
  yield takeEvery(
    projectMeetingRedux.actions.updateProjectMeetingRequest,
    updateMeeting,
    api
  );
  yield takeEvery(
    projectMeetingRedux.actions.deleteProjectMeetingRequest,
    deleteMeeting,
    api
  );

  //report
  yield takeEvery(
    reportRedux.actions.reportPostRequest,
    reportPost,
    api
  );
  yield takeEvery(
    reportRedux.actions.reportProjectRequest,
    reportProject,
    api
  );
  yield takeEvery(
    reportRedux.actions.reportUserRequest,
    reportUser,
    api
  );
  yield takeEvery(
    reportRedux.actions.reportProblemRequest,
    reportProblem,
    api
  );
  yield takeEvery(
    reportRedux.actions.reportCommentRequest,
    reportComment,
    api
  );
  yield takeEvery(
    reportRedux.actions.reportReplyRequest,
    reportReply,
    api
  );


  // chatSaga
  yield takeEvery(
    chatRedux.actions.getAllCollaboratorByProjectIdRequest,
    getAllCollabaratorsByProjectIdSaga,
    api
  );
  yield takeEvery(chatRedux.actions.createProjectGroupRequest, createProjectGroupSaga, api);
  yield takeEvery(chatRedux.actions.getProjectGroupDataRequest, getProjectGroupDetailsSaga, api);

  //notification saga
  yield takeEvery(notificationsRedux.actions.getAllUserNotificationsRequest, getAllUserNotificationsSaga, api);
  yield takeEvery(notificationsRedux.actions.updateNotificationRequest, updateNotificationSaga, api);

  // disconnect session id in login
  yield takeEvery(
    loginRedux.actions.disconnectAndDestroySessionIdRequest,
    disconnectAndDestroySessionIdSaga,
    api
  );
  yield takeEvery(
    loginRedux.actions.generateSessionIdRequest,
    generateSessionIdSaga,
    api
  );

  //events
  yield takeEvery(
    eventsRedux.actions.registerUserForEventsRequest, registerUserInEventSaga, api
  );
  yield takeEvery(
    eventsRedux.actions.createRazorpayOrderRequest, createRazorpayOrderSaga, api
  );
  yield takeEvery(
    eventsRedux.actions.verifyPromoCodeRequest, verifyPromoCodeSaga, api
  );
  yield takeEvery(
    eventsRedux.actions.getRefundRequest, getRefundSaga, api
  );
}
// Takeevery and takelatests are the methods given by redux saga library
// takeevery---- it will watches for specific action to be dispatched and calls the designated function every time that action dispatched
